<template>
  <Modal
    ref="modal"
    maximized
    @hide="$emit('hide')"
  >
    <PersonDetailCard
      ref="card"
      :client-id="clientId"
      @close="close"
      @face-click="openFace"
      @updated="$emit('updated', $event)"
    />

    <FaceDetailDialog
      ref="faceDetail"
      :show-view-person="false"
    />
  </Modal>
</template>

<style scoped>
.q-card {
  border-radius: 0;
}
</style>

<script lang="ts">
import { defineComponent } from 'vue';
import { Person, Face } from '@/analysis/types';
import Modal from '@/components/modal/Modal.vue';
import FaceDetailDialog from '@/analysis/face/FaceDetailDialog.vue';
import PersonDetailCard from './PersonDetailCard.vue';

export default defineComponent({
  emits: ['hide', 'updated'],
  components: {
    Modal,
    PersonDetailCard,
    FaceDetailDialog,
  },
  props: {
    clientId: {
      type: Number,
      required: true,
    },
    person: {
      type: Object as () => Person,
      default: null,
    },
  },
  mounted() {
    if (this.person) {
      this.open(this.person);
    }
  },
  methods: {
    show(): void {
      if (this.person) {
        this.open(this.person);
      }
    },
    open(person: Person): void {
      (this.$refs.modal as any).show();
      this.$nextTick(() => {
        (this.$refs.card as any).open(person);
      });
    },
    close(): void {
      (this.$refs.modal as any).hide();
    },
    openFace(face: Face): void {
      (this.$refs.faceDetail as any).open(face);
    },
  },
});
</script>
